import { cn } from 'modules/v2/common/utils/cn';

import strings from '../../strings';
import { WIZARD_STEP } from '../../constants';

const STEPS = [
  { id: WIZARD_STEP.ASSET, label: strings.wizard.stepAsset },
  { id: WIZARD_STEP.AUDIENCE, label: strings.wizard.stepAudience },
  { id: WIZARD_STEP.REVIEW, label: strings.wizard.stepReview },
  { id: WIZARD_STEP.PAY, label: strings.wizard.stepPay },
];

// Transient wizard states rendered under one of the four visible steps
const STEP_INDEX = {
  [WIZARD_STEP.ASSET]: 0,
  [WIZARD_STEP.AUDIENCE]: 1,
  [WIZARD_STEP.RESOLUTION]: 2,
  [WIZARD_STEP.REVIEW]: 2,
  [WIZARD_STEP.PAY]: 3,
  [WIZARD_STEP.CONFIRMATION]: 3,
};

const WizardStepsHeader = ({ currentStep, onStepSelect }) => {
  const currentIndex = STEP_INDEX[currentStep] ?? 0;

  return (
    <ol className="mb-8 flex flex-wrap items-center gap-2" data-testid="mod-wizard-steps">
      {STEPS.map((step, index) => {
        const isActive = index === currentIndex;
        const isDone = index < currentIndex;
        // Only completed steps are navigable, and only when the parent allows
        // it (pre-submit). Active/upcoming steps are never clickable.
        const isClickable = Boolean(onStepSelect) && isDone;

        const content = (
          <>
            <span
              className={cn(
                'flex h-6 w-6 items-center justify-center rounded-full text-xs font-semibold',
                isActive && 'bg-neutral-800 text-white',
                isDone && 'bg-primary-500 text-neutral-800',
                !isActive && !isDone && 'bg-neutral-200 text-neutral-500',
              )}
            >
              {index + 1}
            </span>
            <span
              className={cn(
                'text-sm',
                isActive ? 'font-semibold text-neutral-800' : 'text-neutral-500',
                isClickable && 'hover:text-neutral-800 hover:underline',
              )}
            >
              {step.label}
            </span>
          </>
        );

        return (
          <li key={step.id} className="flex items-center gap-2">
            {isClickable ? (
              <button
                type="button"
                className="flex items-center gap-2"
                onClick={() => onStepSelect(step.id)}
                data-testid={`mod-wizard-step-${step.id}`}
              >
                {content}
              </button>
            ) : (
              <span className="flex items-center gap-2">{content}</span>
            )}
            {index < STEPS.length - 1 && <span className="mx-1 text-neutral-300">/</span>}
          </li>
        );
      })}
    </ol>
  );
};

export default WizardStepsHeader;
